export class OrderEntryParameters {
}
